export const getFullUrl = () => {
  if (typeof window === 'undefined') return;

  return new URL(window.location.href);
};

export const removeGoogleImageSizeParam = (url: string) => {
  const equalIndex = url.indexOf('=');

  return equalIndex !== -1 ? url.substring(0, equalIndex) : url;
};
